export const IS_WHITE_LABEL = !!import.meta.env.VITE_WHITE_LABEL;
